// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import Media from "react-media";
import Gettext from "../common/Gettext";
import Scrollable from "../common/Scrollable";
import { fontSize } from "../common/styled-mixins";
import StockRow from "./StockRow";
import Tour from "../Tour";

const Table = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  overflow: hidden;

  ${(props) =>
    props.mobile &&
    css`
      width: calc(100vw - 164px);

      /* portrait */
      @media (max-width: 479px) {
        width: calc(100vw - 138px);
      }
    `};
`;

const TableTitleRow = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  width: 100%;
  height: 37px;
  padding-left: 21px;
  padding-right: 21px;
  text-align: center;
  font-size: ${fontSize(12)};
  color: ${(props) => props.theme.accent};

  ${(props) =>
    props.mobile &&
    css`
      padding-left: 12px;
      padding-right: 12px;
    `};
`;

const TableBody = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-self: stretch;
  width: 100%;
  height: calc(100% - 38px);
  padding: 12px;
  padding-right: 0;

  ${(props) =>
    props.mobile &&
    css`
      height: calc(100vh - 45px - 38px);
      padding: 12px;
    `};
`;

const TableTitle = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 50%;
  ${(props) =>
    !props.isNameColumnVisible &&
    css`
      min-width: 74px;
    `}

  ${(props) =>
    props.mobile &&
    props.isNameColumnVisible &&
    css`
      width: 33.3333%;
      min-width: 0;
    `}

  ${(props) =>
    props.mobile &&
    !props.isNameColumnVisible &&
    css`
      width: 50%;
      min-width: 0;
    `}
`;

const TableTitleSeparator = styled.div`
  width: 100%;
  height: 1px;
  margin: 0 12px;
  background-color: ${(props) => props.theme.mainSeparator};
`;

const TitleRow = (props) => (
  <React.Fragment>
    <TableTitleRow mobile={props.mobile}>
      <TableTitle
        mobile={props.mobile}
        isNameColumnVisible={props.isNameColumnVisible}
      >
        <Gettext>Assets</Gettext>
      </TableTitle>
      {props.isNameColumnVisible && (
        <TableTitle mobile={props.mobile}>
          <Gettext>Name</Gettext>
        </TableTitle>
      )}
      <TableTitle
        mobile={props.mobile}
        isNameColumnVisible={props.isNameColumnVisible}
      >
        <Gettext>Income</Gettext>
      </TableTitle>
    </TableTitleRow>
    <TableTitleSeparator />
  </React.Fragment>
);

function StocksTable({ assets, ...props }) {
  const stocks = Object.keys(assets);

  if (!assets) {
    // TODO: Decide, this never happens, can we remove this? or should we fix this?
    // Question is whether we should show table header or not.
    // Possible replacement is check of stocks.length
    return null;
  }

  const firstAsset = assets[stocks[0]];
  const isNameColumnVisible = Boolean(
    firstAsset && firstAsset.description && props.hideName !== true
  );

  const original = React.useRef(null);

  return (
    <Media query="(max-width: 959px)">
      {(matches) => (
        <Table mobile={matches}>
          <TitleRow
            mobile={matches}
            isNameColumnVisible={isNameColumnVisible}
          />
          <TableBody mobile={matches}>
            <Scrollable>
              {stocks.map((key, index) =>
                index === 0 ? (
                  <Tour step="stockSelect" originalRef={original}>
                    {({ next, isOriginal, tour }) => (
                      <StockRow
                        isOriginal={isOriginal}
                        tour={tour}
                        ref={isOriginal ? original : null}
                        key={index}
                        tradeMode={props.tradeMode}
                        item={assets[key]}
                        onClick={() => {
                          next(key);
                          props.onStockClick(key);
                        }}
                        activeAccount={props.activeAccount}
                        isNameColumnVisible={isNameColumnVisible}
                      />
                    )}
                  </Tour>
                ) : (
                  <StockRow
                    key={index}
                    tradeMode={props.tradeMode}
                    item={assets[key]}
                    onClick={() => props.onStockClick(key)}
                    activeAccount={props.activeAccount}
                    isNameColumnVisible={isNameColumnVisible}
                  />
                )
              )}
            </Scrollable>
          </TableBody>
        </Table>
      )}
    </Media>
  );
}

export default StocksTable;



// WEBPACK FOOTER //
// ./src/components/StockMenu/StocksTable.js